import React, { Fragment, useEffect, useState } from "react";
import Countdown from 'react-countdown';
import UserStats from "./UserStats";
import Leaderboard from "./Leaderboard";
import styled from 'styled-components';
import {
  claimRewardsMetaMask,
  claimRewardsWalletConnect,
  claimRewardsBscWallet,
} from "../services/DashboardFunctions";
import {
  getMyDateMetaMask
} from "../services/UserStatsFunctions";

//import AdditionalFunctionality from "./AdditinalFunctionality";
import { getContractOwner } from "../services/AdditionalFunctions";
import { disconnectWalletConnect } from "../services/WalletConnection";
import { useWallet } from "use-wallet";





// useEffect(() => {
//   getTotalHatched(setTotalHatchedPerBIRB);
//   getNestSize(setNestSize);
// }, []);
const checkChangeWalletHeader = localStorage.getItem("wallet-header");

  
const Dashboard = ({
  addr,
  setAddr,
  setShow,
  contract,
  clickClaimReward,
  setClickClaimReward,
  errorSendTransaction,
  setErrorSendTransaction,
}) => {
  //For Binance
  const { reset } = useWallet();

  const [leaderboard, setLeaderboard] = useState([]);
  const [errorClaimReward, setErrorClaimReward] = useState("");
  const [contractOwner, setContractOwner] = useState("");

  const disconnectWallet = () => {
    setAddr("");
    if (localStorage.getItem("wallet-header") === "metamask") {
      localStorage.removeItem("wallet-header");
    } else if (localStorage.getItem("wallet-header") === "binance") {
      //Call Binance disconnection
      reset();
      localStorage.removeItem("wallet-header");
      localStorage.removeItem("binance-addr");
    } else if (localStorage.getItem("walletconnect")) {
      disconnectWalletConnect();
    }
  };
  // console.log(addr);
  // console.log('walletconnect', localStorage.getItem('walletconnect'));
  // console.log(localStorage.getItem('wallet-header'));
  // console.log('addr', addr);

  const connectWallet = () => {
    setShow(true);
  };

  const myDateMetaMaskTest=1623076470*1000;
  const [myDateMetaMask, setMyDateMetaMask] = useState(1000);
  const checkChangeWalletHeader = localStorage.getItem("wallet-header");
  useEffect(() => {
    if (localStorage.getItem("wallet-header") === "metamask") {
      getMyDateMetaMask(setMyDateMetaMask, addr);
    } 
  }, [addr, checkChangeWalletHeader, contract]);

  const claimReward = () => {
    setClickClaimReward(true);
    if (localStorage.getItem("wallet-header") === "metamask") {
      claimRewardsMetaMask(addr, setErrorClaimReward);
    } else if (localStorage.getItem("wallet-header") === "binance") {
      claimRewardsBscWallet(addr, setErrorClaimReward);
    } else if (localStorage.getItem("walletconnect")) {
      claimRewardsWalletConnect(setErrorClaimReward, contract);
    }
    console.log(myDateMetaMask);
  };

  const PurpleCount = styled.div`
  span {
    color: #DAA520;
    font-size: 350%;
    font-weight: bold;
    background-image: linear-gradient(
   to bottom,
   #462523 0,
          #cb9b51 22%, 
   #f6e27a 45%,
   #f6f2c0 50%,
   #f6e27a 55%,
   #cb9b51 78%,
   #462523 100%
   );
    color:transparent;
    -webkit-background-clip:text;
  }
`;

  useEffect(() => {
    getContractOwner(setContractOwner);
  }, [addr]);
  // console.log(localStorage.getItem('wallet-header'));

  useEffect(() => {
    let countError = 0;
    if (addr && leaderboard.length !== 0) {
      leaderboard.forEach((item) => {
        if (addr.toLowerCase() === item.address.toLowerCase()) {
          return;
        } else {
          countError++;
          // setErrorClaimReward('Current Address is not in Top 50 Holders')
        }
      });
      if (leaderboard.length === countError) {
        setErrorClaimReward("Current Address is not in Top 50 Holders");
      } else {
        setErrorClaimReward("");
      }
    }
  }, [addr, leaderboard]);
  
  return (
    <div className="main-content">
      {/* HEADER */}
      <div className="header">
        <div className="container">
          {/* Body */}
          <div className="header-body">
            <div className="row align-items-end">
              <div className="col" style={{ textAlign: "left" }}>
                {/* Pretitle */}
                <h6 className="header-pretitle">Welcome</h6>
                {/* Title */}
                <h1 className="header-title">BNB-REWARD Portal</h1>
              </div>
              <div className="col-auto">
                {addr && localStorage.getItem("wallet-header") ? (
                  //Button
                  <div>
                 
                  <button
                    className="btn btn-light mb-2 lift"
                    onClick={disconnectWallet}
                  >
                   Disconnect  {" "} ({addr})
                  </button>
                  ,</div>
                ) : (
                  // Button
                  <button
                    className="btn btn-success mb-2 lift"
                    onClick={connectWallet}
                  >
                    Connect
                  </button>
                )}
              </div>
            </div>{" "}
            {/* / .row */}
          </div>{" "}
          {/* / .header-body */}
        </div>
      </div>{" "}
      {/* / .header */}
      {/* CARDS */}
      <div className="container">
        {/* Additional Functions for owner */}
        {/* {localStorage.getItem("wallet-header") &&
          addr &&
          contractOwner &&
          contractOwner.toLowerCase() === addr.toLowerCase() && (
            <AdditionalFunctionality addr={addr} contract={contract} />
          )} */}

        <div className="row">
          <div className="col-12 col-lg-3"></div>
          <div className="col-12 col-lg-6">
            {/* Card */}
            <div className="card card-fill-lg">
              <div className="card-body text-center">
                {/* Image */}
                <div className="text-center">
                  <img
                    src="./img/files/earth.png"
                    alt="..."
                    className="img-fluid mt-lg-0 mb-4"
                    style={{ maxWidth: 200 }}
                  />
                </div>
                {/* Heading */}
                {/* Text */}
                <p className="card-text text-muted">
                  BNBREWARD is a higly rewarding procotol on Binance Smart
                  Chain.Hold $BNBREWARD tokens and earn $BNB.
                </p>
                {/* Button */}
                {addr && localStorage.getItem("wallet-header") && (
                  <div class="text-center">
                  <button
                    className="btn btn-gold btn-primary lift"
                    onClick={()=>{}}
                  >
                    Buy Now
                  </button>
                  </div>
                )}
                {/* Alert */}
                {localStorage.getItem("wallet-header") && errorSendTransaction && (
                  <div
                    className="alert alert-warning alert-dismissible fade show mt-3 mb-0"
                    role="alert"
                  >
                    <h2>
                      {errorSendTransaction.timeStatus ? (
                        <Fragment>OOOPS... </Fragment>
                      ) : (
                        <Fragment>No $BNBREWARD </Fragment>
                      )}

                      <span role="img" aria-label="sad-emoji">
                        😢
                      </span>
                    </h2>
                    {errorSendTransaction.timeStatus ? (
                      <>{errorSendTransaction.msg}</>
                    ) : (
                      <Fragment>
                        The account connected to your wallet doesn't seem to
                        hold any BIRB. <strong>Acquire BIRB</strong> to play or
                        connect another account.
                      </Fragment>
                    )}

                    {/* Button */}
                    <button
                      type="button"
                      className="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">×</span>
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-3"></div>
        </div>
        <div className="row">
          <div className="col-12 col-lg-3"></div>
          <div className="col-12 col-lg-6">
            {/* Card */}
            <div className="card card-fill-lg">
              <div className="card-body text-center">
                {/* Image */}
                <div className="text-center">
                  <img
                    src="./img/files/3dbnb.gif"
                    alt="..."
                    className="img-fluid mt-lg-0 mb-4"
                    style={{ maxWidth: 200 }}
                  />
                </div>
                {/* Heading */}
                <h2 className="mb-3 mt-3">Claim BNB</h2>
                {/* Text */}
                <p className="card-text text-muted">
                  This delicious reward is available to all the $BNBREWARD
                  holders.
                </p>
                {
                  /*Timer*/
               
                }
                <PurpleCount>
                <Countdown date={myDateMetaMask}
                
                >
                
                {/* Button */}
                {addr && localStorage.getItem("wallet-header") && (
                  <button
                    className="btn btn-block btn-primary lift"
                    onClick={claimReward}
                  >
                    Claim Rewards   {myDateMetaMask}
                  </button>
                )}
                </Countdown>
                </PurpleCount>
                {/* Alert */}
                {localStorage.getItem("wallet-header") &&
                  errorClaimReward &&
                  clickClaimReward && (
                    <div
                      className="alert alert-warning alert-dismissible fade show mt-3 mb-0"
                      role="alert"
                    >
                      <h2>
                        Not a TOP 50 Holder{" "}
                        <span role="img" aria-label="sad-emoji">
                          😢
                        </span>
                      </h2>
                      Oops, It looks like you're not in the top 50 holders to
                      receive this reward.
                      {/* Button */}
                      <button
                        type="button"
                        className="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">×</span>
                      </button>
                    </div>
                  )}
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-3"></div>
        </div>
        <UserStats addr={addr} contract={contract} />
        {/* <UserStats /> */}

        <Leaderboard
          leaderboard={leaderboard}
          setLeaderboard={setLeaderboard}
        />
      
      </div>
    </div>
  );
};

export default Dashboard;
